const listFitsInWrapper = ({ wrapper, list }) =>
  wrapper.scrollWidth >= list.scrollWidth;

export const showArrowLeft = ({ wrapper, list }) =>
  !listFitsInWrapper({ wrapper, list }) && list.scrollLeft > 0;

export const showArrowRight = ({ wrapper, list }) =>
  !listFitsInWrapper({ wrapper, list }) &&
  list.scrollLeft !== list.scrollWidth - list.clientWidth;

export default {
  showArrowLeft,
  showArrowRight
};
